module.exports = __webpack_public_path__ + "img/minus.9661ba0b.svg";